import { SupportedNetworks } from '../../config/networkAddresses';
import { getMultiNetworkPrice } from './helpers/get-multi-network-price';
import { getSingleNetworkPrice } from './helpers/get-single-network-price';
import { CURRENT_VERSION, getUrls } from '../../config/environment';
import { isEVMNetwork, isSolanaNetwork, isSuiNetwork } from '../../../utils/validation/network-validation';
// This helper is so other parts of the Genius system can access price quotes through a wrapper url/single function
export default async function getQuotingEnginePrice({ PKP, cloudWallet, solanaAddress, suiAddress, tokensIn, tokensOut, fromSlippage, permitBatchDetails, permitSignatures, baseUrl = '/api/wrapper?target=', priorityFee, }) {
    var _a, _b, _c;
    console.log('starting quote fetch', {
        cloudWallet,
        tokensIn,
        tokensOut,
        fromSlippage,
        permitBatchDetails,
        permitSignatures,
        PKP,
        priorityFee,
    });
    let geniusQuotingEngineUrl = baseUrl + getUrls().QUOTER_URL;
    console.log('geniusQuotingEngineUrl', geniusQuotingEngineUrl);
    try {
        console.log('QUOTE 1', geniusQuotingEngineUrl);
        const numInputNetworks = new Set(tokensIn === null || tokensIn === void 0 ? void 0 : tokensIn.map((token) => token.network)).size;
        const numOutputNetworks = new Set(tokensOut === null || tokensOut === void 0 ? void 0 : tokensOut.map((token) => token.network));
        const numUniqueNetworks = new Set([
            ...tokensIn === null || tokensIn === void 0 ? void 0 : tokensIn.map((token) => token.network),
            ...tokensOut === null || tokensOut === void 0 ? void 0 : tokensOut.map((token) => token.network),
        ]).size;
        const numTokens = tokensIn.length;
        let response = null;
        if (!numInputNetworks || !numTokens) {
            throw new Error('Invalid input');
        }
        const isMultiInMultiOutOnSameNetwork = numUniqueNetworks === 1 && (tokensIn === null || tokensIn === void 0 ? void 0 : tokensIn.length) > 1 && (tokensOut === null || tokensOut === void 0 ? void 0 : tokensOut.length) > 1;
        console.log('starting quote fetch numUniqueNetworks', numUniqueNetworks, isMultiInMultiOutOnSameNetwork, tokensIn, tokensOut);
        if (numUniqueNetworks == 1 && !isMultiInMultiOutOnSameNetwork) {
            console.log('QUOTE SingleNetwork', tokensIn[0].network, tokensIn === null || tokensIn === void 0 ? void 0 : tokensIn.map((token) => token.address), tokensOut === null || tokensOut === void 0 ? void 0 : tokensOut.map((token) => token.address), tokensIn === null || tokensIn === void 0 ? void 0 : tokensIn.map((token) => token.amount), cloudWallet, tokensOut === null || tokensOut === void 0 ? void 0 : tokensOut.map((token) => token.percentage), geniusQuotingEngineUrl);
            const isSui = isSuiNetwork((_a = tokensIn === null || tokensIn === void 0 ? void 0 : tokensIn[0]) === null || _a === void 0 ? void 0 : _a.network);
            const isEVM = isEVMNetwork((_b = tokensIn === null || tokensIn === void 0 ? void 0 : tokensIn[0]) === null || _b === void 0 ? void 0 : _b.network);
            const isSolana = isSolanaNetwork((_c = tokensIn === null || tokensIn === void 0 ? void 0 : tokensIn[0]) === null || _c === void 0 ? void 0 : _c.network);
            const trader = isSui ? suiAddress : isSolana ? solanaAddress : cloudWallet;
            console.log('QUOTE SingleNetwork', trader, suiAddress, cloudWallet, PKP);
            console.log(`FETCHING ----> getSingleNetworkPrice`, trader);
            //@ts-ignore
            response = await getSingleNetworkPrice({
                //@ts-ignore
                PKP,
                network: tokensIn[0].network,
                tokensIn: tokensIn === null || tokensIn === void 0 ? void 0 : tokensIn.map((token) => token.address),
                tokensOut: tokensOut === null || tokensOut === void 0 ? void 0 : tokensOut.map((token) => token.address),
                amountsIn: tokensIn === null || tokensIn === void 0 ? void 0 : tokensIn.map((token) => token.amount),
                fromAddress: trader,
                slippages: tokensIn === null || tokensIn === void 0 ? void 0 : tokensIn.map(() => fromSlippage),
                baseUrl: geniusQuotingEngineUrl,
                permitBatchDetail: permitBatchDetails[0],
                permitSignature: permitSignatures[0],
                priorityFee: priorityFee,
            });
        }
        else {
            console.log('solanaAddresskwieieiiew', solanaAddress);
            const tokenInOrders = tokensIn === null || tokensIn === void 0 ? void 0 : tokensIn.map((token) => ({
                tokenIn: token.address,
                network: token.network,
                amountIn: token.amount,
                fromAddress: cloudWallet,
                solanaFromAddress: solanaAddress,
            }));
            const tokenOutOrders = tokensOut === null || tokensOut === void 0 ? void 0 : tokensOut.map((token) => {
                var _a;
                const network = token.network;
                const executorContract = (_a = SupportedNetworks(CURRENT_VERSION)[network]) === null || _a === void 0 ? void 0 : _a.executor;
                return {
                    tokenOut: token.address,
                    network,
                    fromAddress: executorContract,
                };
            });
            console.log('QUOTE MultiNetwork', tokenInOrders, tokenOutOrders, fromSlippage);
            console.log('baseurl', geniusQuotingEngineUrl);
            //@ts-ignore
            response = await getMultiNetworkPrice({
                PKP,
                tokenInOrders: tokenInOrders,
                tokenOutOrders: tokenOutOrders,
                fromSlippage,
                permitBatchDetails,
                permitSignatures,
                baseUrl: geniusQuotingEngineUrl,
                priorityFee: priorityFee
            });
        }
        if (!response) {
            throw new Error('Invalid response');
        }
        //@ts-ignore
        if (response === null || response === void 0 ? void 0 : response.error) {
            // console.error('Error fetching price quote', response.error);
            //@ts-ignore
            return response;
        }
        //@ts-ignore
        return Object.assign({}, response);
    }
    catch (error) {
        // console.error('Error fetching price quote', error);
        //@ts-ignore
        return { error: error.message };
    }
}
